import React from "react";
import { Helmet } from "react-helmet";
const ArtistStatement = () => {
  return (
    <>
      <Helmet>
        <title>Harry Boone | Media Coverage & Reviews</title>
        <meta
          name="description"
          content="Explore media coverage, reviews, and interviews featuring Harry Boone. Stay updated with the latest press releases and articles about his contemporary abstract art."
        />
      </Helmet>
      <div id="Statement" className="top-spacing">
        <div className="container">
          <div className="row">
            <div>
              <h2>PRESS</h2>
              <p>
                “To see Harry Boone’s work as a synthesis of influences in the
                composition and color of Wayne Thiebaud, the painterly quality
                of Nicholas de Staël, and the energy of Hans Hoffman would only
                give the slightest indications of Boone’s achievement in
                conveying his personal experiences into expressions of light and
                color. Boone does not paint directly from life but rather, using
                the viewed subject as a starting point, he develops his
                paintings as a changing experience. . . . Energy comes through
                the source of color and eclipsing in a painting, and it creates
                a system of oppositions or tensions. The truth manifests itself
                in the form of a dialectic. The painting speaks back to you.”{" "}
                <br></br>
                <br></br>
                <p className="text-bold">
                  Theodore Salazar, Professor of Art, Gallaudet University, and
                  Critic writing for <i>EYEWASH</i>
                </p>
                <hr></hr>
                “Boone’s answer to this detached formalism is in the choice of
                much more psychologically resonant subjects. He isolates images
                of fetishistic objects . . . These humorously animated male and
                female symbols serve for an absurd and dramatic confrontation.”
                <br></br>
                <br></br>
                <p className="text-bold">
                  Mark Kingsley, Independent Art Critic writing for the{" "}
                  <i>ARTPAPERS</i>{" "}
                </p>
                <hr></hr>
                “Boone is not the traditional frontiersman, except in
                appearance, but he has met his own contemporary challenge in
                dealing with the pedestrian world and transforming it. The
                familiar objects are abstracted within their very concreteness.
                His is a formalist and serialist sensibility. There is no
                emotional baggage from the political or sexual world – rather
                the kind and direction of impasto strokes, their size,
                palpability, viscosity, the deliberate color dialogue is allowed
                to manifest itself . . . The color soars, engendering that sense
                of harmony and equilibrium for which we long.”<br></br>
                <br></br>
                <p className="text-bold">
                  Dr. Carol Ravenal, Associate Professor of Art History,
                  American University and Critic writing for the{" "}
                  <i>Washington Review</i>{" "}
                </p>
                <hr></hr>
                “Harry Boone is a master of spatial relationships in both his
                large oils and small pastels. . . . isolate small objects in
                space, surrounded by brilliant shadows and auras as shimmeringly
                appealing as those of Wayne Thiebaud.”<br></br>
                <br></br>
                <p className="text-bold">
                  Claude LeSuer, Independent Art Critic writing in{" "}
                  <i>ARTSPEAK</i> NYC
                </p>
                <hr></hr>
                “[Boone] inspire[s] viewers to reminisce about the works of
                Californian Wayne Thiebaud. He is a master with a brush, and his
                marks themselves are interesting and his colors are more than
                slightly arousing. They are rich combinations and offer the
                viewer some of what painters like Manet could offer – the closer
                we get, the more impressive the works are.” <br></br>
                <br></br>
                <p className="text-bold">
                  Diane Mead, Independent Art Critic writing for{" "}
                  <i>THE MACON TELEGRAPH AND NEWS</i>
                </p>
                <hr></hr>
                “Boone’s work immediately suggests that of Wayne Thiebaud, but
                is also compositionally reminiscent of Edward Hopper’s sequence
                of gasoline pumps . . . . In . . . Boone’s paintings rhythmic
                spacing enlivens these otherwise static objects. The color and
                light in Hopper’s paintings can also be found in Boone’s.”{" "}
                <br></br>
                <br></br>
                <p className="text-bold">
                  Roy Gary, Professor of Art at SUNY-Stoney Brook, and Critic
                  writing for <i>ARTPAPERS</i>
                </p>
                <hr></hr>
                “Two of the most original out of the nine painters are Boone, .
                . . [whose] large canvases depict a single construction, like a
                swing set, but pared down to its essential form and scaled to
                fill up the picture plane. His colors are strong-gutsy and not
                pretty . . . . These playground shapes are changed into iconic
                forms.” <br></br>
                <br></br>
                <p className="text-bold">
                  Lydia Finkelstein, Independent Art Critic writing for the{" "}
                  <i>BLOOMINGTON [IN] HERALD TIMES</i>{" "}
                </p>
                <hr></hr>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ArtistStatement;
